import { Controller } from "@hotwired/stimulus"

// The media monitoring keyword list: when the publicist leaves a keyword
// field, ask the read-only keyword check whether it might be off and show its
// notes under that field (Media_Monitoring_Results_Plan.md v2, section 8).
// On blur only, never while typing, and it never blocks Save: the owner wants
// publicists free to add album names and other tags. The words come from the
// server (KeywordCheck), so this file spells none of them.
export default class extends Controller {
  static values = { url: String }

  async check(event) {
    const input = event.target
    const notes = input.closest(".keyword-row")?.querySelector("[data-keyword-notes]")
    if (!notes) return
    if (!input.value.trim()) { this.paint(notes, []); return }

    // The whole list as the form holds it now, so a duplicate is judged
    // against the fields above this one, exactly as it is after a Save.
    const inputs = Array.from(this.element.querySelectorAll('input[name="media_monitor[keywords][]"]'))
    const params = new URLSearchParams()
    inputs.forEach((field) => params.append("keywords[]", field.value))
    params.append("index", String(inputs.indexOf(input)))
    try {
      const res = await fetch(`${this.urlValue}?${params}`, { headers: { Accept: "application/json" }, credentials: "same-origin" })
      if (!res.ok) return
      const data = await res.json()
      this.paint(notes, data.notes || [])
    } catch (e) { /* the page after Save says it anyway */ }
  }

  paint(notes, list) {
    notes.replaceChildren(...list.map((note) => {
      const line = document.createElement("p")
      line.className = `text-xs ${note.tone === "warning" ? "text-[var(--color-status-needs-attention)]" : "text-[#8C8C8C]"}`
      line.dataset.noteKind = note.kind
      line.textContent = note.text
      return line
    }))
    notes.hidden = list.length === 0
  }
}
